<template>
	<div data-app :class="['a-c-detail', isReply ? 'right-memo-box' : '']">
		<PageHeader :title="`${isReply ? '답변' : '댓글'} 상세정보`">
			<div>
				<RouterLink
					v-if="isReply"
					:to="`/qna/a/${details.id}/c?qId=${qnaId}`"
					class="btn blue a-c-detail__header-btn"
					v-text="'댓글 등록'"
				/>
				<button
					v-if="details.isOfficial"
					type="button"
					class="btn red a-c-detail__header-btn"
					v-text="`${isReply ? '답변' : '댓글'} 삭제`"
					@click="deleteQna"
				/>
			</div>
		</PageHeader>
		<form @submit.prevent="submitData">
			<ManagingSection :columnCount="2">
				<ManagingBox :title="`${isReply ? '답변' : '댓글'}번호`">{{
					details.id
				}}</ManagingBox>
				<ManagingBox title="등록일">{{
					details.createdAt
				}}</ManagingBox>
				<ManagingBox title="작성자">
					<template v-if="details.isOfficial">관리자</template>
					<RouterLink
						v-else
						:to="`/register/register-info/${details.register.idRegister}`"
						target="_blank"
						class="link"
						v-text="details.register.nickName"
					/>
				</ManagingBox>
				<ManagingBox title="신고건">
					<RouterLink
						:to="`/qna/a/report/list?target=qnaReplyId&value=${details.id}`"
						target="_blank"
						class="link"
						v-text="details.reportCount"
					/>
				</ManagingBox>
			</ManagingSection>
			<ManagingSection :splice="true">
				<ManagingBox v-if="details.isOfficial" title="브랜드">
					<SearchBrand
						ref="searchBrand"
						searcherPlaceholder="브랜드명를 입력하세요"
						selectedPlaceholder="브랜드를 선택해 주세요"
						:useLastBrand="false"
						:showIfIsDisplay="true"
						@change="idBrandChange"
					/>
				</ManagingBox>
				<ManagingBox title="상태">
					<RadioList
						v-model="details.state"
						:disabledIds="
							details.isOfficial
								? ['정상', '차단', '검수']
								: ['검수']
						"
						:disabled="true"
						:radioList="stateList"
					/>
				</ManagingBox>
				<ManagingBox
					v-if="details.state === '차단'"
					title="차단사유"
					:horizontalMode="true"
					contsClass="a-c-detail__static-code-wrapper"
				>
					<Selector
						v-model="selectedStaticCode1"
						:optionList="staticCodes"
						valueKey="code"
					/>
					<Selector
						v-model="selectedStaticCode2"
						:optionList="staticCodes"
						valueKey="code"
					/>
					<p
						v-if="!selectedStaticCode1"
						class="a-c-detail__static-code-err"
						v-text="'첫번째 사유는 필수로 선택해야 합니다!'"
					/>
				</ManagingBox>
				<ManagingBox title="내용">
					<TextCounter
						v-if="details.isOfficial"
						v-model="details.text"
						:useTextarea="true"
						:useLineLimit="false"
						:maxLength="1000"
						:useComma="true"
						:textCounterType="'reply'"
					/>
					<input
						v-else
						v-model="details.text"
						:disabled="true"
						type="text"
					/>
				</ManagingBox>
				<ManagingBox title="연관제품">
					<ProductSearcher2 @change="onSelectProduct" />
					<table class="simple-table a-c-detail__pdt-table">
						<thead>
							<tr>
								<th>제품항번</th>
								<th>이미지</th>
								<th>브랜드명</th>
								<th>제품명</th>
								<th>노출</th>
								<th>단종</th>
								<th>제거</th>
							</tr>
						</thead>
						<tbody v-if="productList.length">
							<tr v-for="item in productList" :key="item.id">
								<td>{{ item.idProduct }}</td>
								<td>
									<img :src="item.imageUrl" />
								</td>
								<td>{{ item.brand.brandTitle }}</td>
								<td>{{ item.productTitle }}</td>
								<td :class="{ 'font-red': !item.isDisplay }">
									{{ item.isDisplayText }}
								</td>
								<td :class="{ 'font-red': item.isDiscontinue }">
									{{ item.isDiscontinueText }}
								</td>
								<td>
									<v-icon
										color="red"
										@click="removeProduct(item.idProduct)"
									>
										mdi-minus-circle
									</v-icon>
								</td>
							</tr>
						</tbody>
						<tbody v-else>
							<tr>
								<td colspan="7">등록된 제품이 없습니다.</td>
							</tr>
						</tbody>
					</table>
				</ManagingBox>
				<ManagingBox v-if="details.isOfficial" title="연관 캐스트">
					<SearchCast
						searchPlaceholder="캐스트 검색 (항번으로만 검색)"
						castSearchType="castId"
						@change="castChange"
					/>
					<table class="table-inner a-c-detail__cast-table">
						<thead>
							<tr>
								<th>캐스트 항번</th>
								<th>이미지</th>
								<th>캐스트명</th>
								<th>제거</th>
							</tr>
						</thead>
						<tbody v-if="castList.length">
							<tr v-for="item in castList" :key="item.idProduct">
								<td>{{ item.idPouch }}</td>
								<td>
									<img :src="item.pouchImageUrl" />
								</td>
								<td>{{ item.pouchTitle }}</td>
								<td>
									<button
										type="button"
										class="btn-minus"
										@click="removeCast(item.idPouch)"
									>
										<i class="fa fas fa-minus" />
									</button>
								</td>
							</tr>
						</tbody>
						<tbody v-else>
							<td colspan="4">등록된 캐스트가 없습니다.</td>
						</tbody>
					</table>
				</ManagingBox>
			</ManagingSection>
			<div class="btn-wrap-main">
				<button
					type="button"
					class="btn-main"
					v-text="'취소'"
					@click="$router.go(-1)"
				/>
				<button
					:disabled="disableSubmit"
					type="submit"
					class="btn-main blue"
					v-text="'수정'"
				/>
			</div>
		</form>
		<RightMemoBox v-if="isReply" refType="qna_reply" :refId="id" />
	</div>
</template>
<script>
	import isEqual from 'lodash/isEqual';
	import compact from 'lodash/compact';
	import find from 'lodash/find';
	import map from 'lodash/map';
	import moment from 'moment';
	import { mapState, mapGetters } from 'vuex';
	import PageHeader from '@/components/PageHeader.vue';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import SearchBrand from '@/components/SearchBrand.vue';
	import RadioList from '@/components/RadioList.vue';
	import Selector from '@/components/Selector.vue';
	import TextCounter from '@/components/TextCounter.vue';
	import ProductSearcher2 from '@/components/ProductSearcher2.vue';
	import SearchCast from '@/components/SearchCast.vue';
	import RightMemoBox from '@/components/RightMemoBox.vue';

	export default {
		name: 'QnaACDetail',
		components: {
			PageHeader,
			ManagingSection,
			ManagingBox,
			SearchBrand,
			RadioList,
			Selector,
			TextCounter,
			ProductSearcher2,
			SearchCast,
			RightMemoBox,
		},
		props: {
			isReply: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				id: Number(this.$route.params._id),
				details: { register: {} },
				originState: '',
				selectedStaticCode1: null,
				selectedStaticCode2: null,
				officialRefId: '',
				productList: [],
				prdIdListOrigin: [],
				qnaId: '',
				castList: [],
				stateList: [
					{ id: '정상', value: '정상' },
					{ id: '차단', value: '차단' },
					{ id: '검수', value: '검수' },
				],
				maxProducts: 5,
			};
		},
		computed: {
			...mapState({
				staticCodes: state =>
					state.filter.staticCodes.filter(
						item => item.parent_code === 'QNA_BLOCK'
					),
				maxProductLength: state => state.qna.maxAttachProductLength,
			}),
			...mapGetters({
				getParsedText: 'qna/parsedText',
			}),
			stateChange() {
				return !isEqual(this.originState, this.details.state);
			},
			prdChanged() {
				return !isEqual(
					this.prdIdListOrigin,
					this.productList.map(item => item.idProduct)
				);
			},
			disableSubmit() {
				return (
					!(this.details.state === '차단'
						? (!!this.selectedStaticCode1 &&
								map(this.details.staticCodeList, 'code').join(
									','
								) !=
									compact([
										this.selectedStaticCode1,
										this.selectedStaticCode2,
									]).join(',')) ||
							this.prdChanged
						: this.details.state != this.originState ||
							this.prdChanged) && !this.details.isOfficial
				);
			},
		},
		mounted() {
			this.initData();
		},
		methods: {
			async initData() {
				try {
					const { data } = await this.$axiosAdmin2.get(
						`/api/qna/reply/${this.id}`
					);

					const details = (this.details = {
						...data,
						createdAt: moment(data.createdAt).format(
							'YYYY-MM-DD HH:mm'
						),
					});

					this.originState = details.state;
					this.selectedStaticCode1 =
						details.staticCodeList[0]?.code || null;
					this.selectedStaticCode2 =
						details.staticCodeList[1]?.code || null;
					this.officialRefId = details.officialRefId;
					this.productList = details.qnaReplyProductList.map(
						item => ({
							...item,
							isDisplayText: this.getParsedText(
								'isDisplay',
								item.isDisplay ? 1 : 0
							),
							isDiscontinueText: this.getParsedText(
								'isDiscontinue',
								item.isDiscontinue ? 1 : 0
							),
						})
					);
					this.prdIdListOrigin = details.qnaReplyProductList.map(
						item => item.product_id
					);
					this.qnaId = details.qna.id;
					this.castList = details.qnaReplyPouchList;

					await this.$nextTick();

					if (details.isOfficial) {
						this.$refs.searchBrand.setBrand(
							details.officialRefId,
							details.officialBrand.brandTitle
						);
					}
				} catch (err) {
					console.error(err);
					alert('데이터를 불러오는데 실패했습니다.');
				}
			},
			async deleteQna() {
				try {
					if (!confirm('답변을 삭제하시겠습니까?')) return;
					await this.$axiosAdmin2.delete(
						`/api/qna/reply/${this.details.id}`
					);
					alert('삭제되었습니다.');
					this.$router.push(
						this.isReply ? '/qna/a/list' : '/qna/c/list'
					);
				} catch (err) {
					alert(
						'삭제에 실패하였습니다. 지속적인 문제 발생시 개발팀에 문의주세요.'
					);
					console.error(err);
				}
			},
			validation() {
				if (this.details.isOfficial) {
					if (!this.officialRefId) {
						alert(
							'관리자가 작성한 답변은 브랜드 입력이 필수값입니다'
						);
						return false;
					}
					if (this.details.text.trim().length === 0) {
						alert('내용을 입력해주세요');
						return false;
					}
				}
				return true;
			},
			getParams() {
				const details = this.details;

				const params = {
					productIdList: this.productList.map(item => item.idProduct),
				};

				if (details.isOfficial) {
					params.text = details.text;
					params.officialRefId = this.officialRefId;
					params.pouchIdList = this.castList.map(
						item => item.idPouch
					);
				} else {
					if (this.stateChange) {
						params.updateState = { state: details.state };

						if (details.state === '차단') {
							params.updateState.staticCodeList = compact([
								this.selectedStaticCode1,
								this.selectedStaticCode2,
							]).map(code => ({ code }));
						}
					}
				}

				return params;
			},
			async submitData() {
				if (!this.validation()) return;
				try {
					const params = this.getParams();
					await this.$axiosAdmin2.put(
						`/api/qna/reply/${this.details.id}`,
						params
					);
					this.$router.go(-1);
				} catch (err) {
					console.error(err);
					alert('데이터를 수정하는데 실패했습니다.');
				}
			},
			idBrandChange(changes) {
				this.officialRefId = changes.idBrand;
			},
			onSelectProduct(item) {
				if (
					find(this.productList, { productId: item.idProduct }) ||
					this.maxProductLength <= this.productList.length
				)
					return;

				const isDiscontinue = item.isDiscontinue ? 1 : 0;
				const isDisplay = item.isDisplay ? 1 : 0;

				this.productList.push({
					idProduct: item.idProduct,
					productTitle: item.productTitle,
					brand: { brandTitle: item.brandTitle },
					imageUrl: item.filePath,
					isDiscontinue,
					isDiscontinueText: this.getParsedText(
						'isDiscontinue',
						isDiscontinue
					),
					isDisplay,
					isDisplayText: this.getParsedText('isDisplay', isDisplay),
					temp: true,
				});
			},
			removeProduct(idProduct) {
				this.productList = this.productList.filter(
					item => item.idProduct !== idProduct
				);
			},
			castChange(cast) {
				if (!cast) return;

				if (this.castList.length >= this.maxProducts) {
					alert('최대 5개까지 등록이 가능합니다.');
					return;
				}

				if (this.castList.some(item => item.idPouch === cast.idPouch)) {
					alert('이미 추가된 캐스트입니다.');
				} else {
					this.castList = [...this.castList, cast];
				}
			},
			removeCast(idPouch) {
				this.castList = this.castList.filter(
					item => item.idPouch !== idPouch
				);
			},
		},
	};
</script>
<style lang="scss" scoped>
	.a-c-detail {
		&__header-btn {
			margin-left: 8px;

			&:first-child {
				margin-left: 0;
			}
		}

		&::v-deep .a-c-detail__static-code-wrapper {
			flex-wrap: wrap;
		}

		&__static-code-err {
			width: 100%;
			color: $red;
		}

		&__pdt-table {
			margin-top: 8px;
			table-layout: fixed;

			thead {
				tr {
					height: 40px;
				}

				th {
					padding: 6px 0;
					text-align: center;

					&:nth-child(1),
					&:nth-child(2) {
						width: 70px;
					}

					&:nth-child(3) {
						width: 140px;
					}

					&:nth-child(4) {
						width: auto;
					}

					&:nth-child(5),
					&:nth-child(6),
					&:nth-child(7) {
						width: 50px;
					}
				}
			}

			tbody {
				td {
					width: auto;
					text-align: center;
					padding: 6px;
				}
			}
		}

		&__cast-table {
			th,
			td {
				&:nth-child(1),
				&:nth-child(4) {
					width: 70px;
				}

				&:nth-child(2) {
					width: 200px;
				}
			}
		}
	}
</style>
